// Modal para editar um pagamento existente.

import React from "react";
import axios from "axios";

const UpdatePagamentoModal = ({
    BANK_OPTIONS,
    PAYMENT_TYPES,
    token,
    changeInputName,
    selectedPayment,
    allInputChange,
    setSelectedPayment,
    moneyInputChange,
    formatCpf_Cnpj
}) => {
    // Funções auxiliares de arquivos
    const removeAttachmentPaymentEdit = (event) => {
        const inputFile = document.querySelector("#upload3");
        const attachments = document.querySelector("#arquivosAddEdit"); // obtém todos os elementos .row dentro do divUp1
        if (inputFile) {
            inputFile.value = "";
            attachments.remove();
        }
    };

    const selectedAttachmentEditar = (event) => {
        let file = event.target.files;
        const verifyFile = document.querySelector("#arquivosAddEdit");
        if (verifyFile) {
            verifyFile.remove();
        }
        const novos = document.querySelector("#novoAnexoEditar");
        const rowDiv = document.createElement("div");
        rowDiv.className = "row";
        rowDiv.id = "arquivosAddEdit";

        const col7Div = document.createElement("div");
        col7Div.className = "col-12";

        const label = document.createElement("label");
        label.textContent = `${file[0].name}`;
        const spanUpload = document.createElement("span");
        spanUpload.className = "hidden-xs";
        const iconUp = document.createElement("i");
        iconUp.className =
            "fa fa-minus-circle ml-3 btn-remove-anexo text-danger";
        iconUp.style.fontSize = "1.25em";
        iconUp.style.position = "relative";
        iconUp.style.top = ".15em";
        iconUp.onclick = removeAttachmentPaymentEdit;
        spanUpload.appendChild(iconUp);
        col7Div.appendChild(label);
        col7Div.appendChild(spanUpload);
        rowDiv.appendChild(col7Div);

        //divUpload.insertBefore(rowDiv, newAtt)
        novos.appendChild(rowDiv);
    };

    function clickUploadUpdatePagamento() {
        const inputFile = document.getElementById("upload3");
        inputFile.click();
    }

    function apagarAnexo() {
        console.log("apagando....");
        document.querySelector("#anexoEdit").setAttribute("disabled", "");
        document.querySelector("#anexoDiv").style.display = "none";
    }

    // Funções de pagamento
    function tipoPagamentoEdit() {
        let tipo = document.querySelector("#tipoEdit");
        console.log("------------> ");
        if (tipo.value == "Acordo") {
            console.log("Dentro");
            let acordo = (document.querySelector("#classEdit").style.display =
                "block");
        } else {
            let acordo = (document.querySelector("#classEdit").style.display =
                "none");
        }
    }
    function startPayment() {
        if (selectedPayment.tipo == "Acordo") {
            return (
                <div>
                    <label className="required" for="m-cadastrar-descricaoLbl">
                        Informe o tipo de guia
                    </label>

                    <select
                        class="form-control"
                        id="tipoEdit"
                        name="tipoEdit"
                        onClick={() => tipoPagamentoEdit()}
                        style={{ visibility: "visible", display: "block" }}
                        disabled
                    >
                        <option selected>{selectedPayment.tipo}</option>
                        {PAYMENT_TYPES.map((type) => (
                            <option key={type}>{type}</option>
                        ))}
                    </select>
                    <div
                        id="classEdit"
                        className
                        style={{ visibility: "visible", display: "block" }}
                    >
                        <label className="required" htmlFor="m-cadastrar-nomes">
                            Nome
                        </label>
                        <input
                            id="nomes"
                            className="form-control"
                            maxLength={50}
                            type="text"
                            name="nomes"
                            value={selectedPayment.nome}
                            onChange={(event) =>
                                changeInputName(event, setSelectedPayment)
                            }
                        />
                        <label className="required" htmlFor="m-cadastrar-banco">
                            Banco
                        </label>
                        <select
                            type="text"
                            id="banco"
                            className="form-control"
                            name="banco"
                        >
                            <option selected>{selectedPayment.banco}</option>
                            {BANK_OPTIONS.map((bank) => (
                                <option key={bank}>{bank}</option>
                            ))}
                        </select>
                        <label className="required" htmlFor="m-cadastrar-cpf">
                            CPF/CNPJ
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            id="cpf"
                            name="cpf"
                            onInput={formatCpf_Cnpj}
                            value={selectedPayment.cpf}
                            onChange={(event) =>
                                allInputChange(event, setSelectedPayment)
                            }
                        />
                        <label
                            className="required"
                            htmlFor="m-cadastrar-agencia"
                        >
                            Agência
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            maxLength={4}
                            minLength={4}
                            id="agencia"
                            name="agencia"
                            value={selectedPayment.agencia}
                            onChange={(event) =>
                                allInputChange(event, setSelectedPayment)
                            }
                        />
                        <label className="required" htmlFor="m-cadastrar-conta">
                            Conta
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            maxLength={11}
                            minLength={5}
                            id="conta"
                            name="conta"
                            value={selectedPayment.conta}
                            onChange={(event) =>
                                allInputChange(event, setSelectedPayment)
                            }
                        />
                        <label
                            className="required"
                            htmlFor="m-cadastrar-digito"
                        >
                            Dígito
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            maxLength={1}
                            minLength={1}
                            id="digito"
                            name="digito"
                            value={selectedPayment.digito}
                            onChange={(event) =>
                                allInputChange(event, setSelectedPayment)
                            }
                        />
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <label className="required" for="m-cadastrar-descricaoLbl">
                        Informe o tipo de guia
                    </label>
                    <select
                        class="form-control"
                        id="tipoEdit"
                        name="tipoEdit"
                        onClick={() => tipoPagamentoEdit()}
                        style={{ visibility: "visible", display: "block" }}
                        disabled
                    >
                        <option selected>{selectedPayment.tipo}</option>
                        {PAYMENT_TYPES.map((type) => (
                            <option key={type} value={type}>
                                {type}
                            </option>
                        ))}
                    </select>
                    <div
                        id="classEdit"
                        className
                        style={{ visibility: "visible", display: "none" }}
                    >
                        <label className="required" htmlFor="m-cadastrar-nomes">
                            Nome
                        </label>
                        <input
                            className="form-control"
                            maxLength={50}
                            type="text"
                            id="nomes"
                            name="nomes"
                            value={selectedPayment.nome}
                            onChange={(event) =>
                                changeInputName(event, setSelectedPayment)
                            }
                        />
                        <label className="required" htmlFor="m-cadastrar-banco">
                            Banco
                        </label>
                        <select
                            type="text"
                            id="banco"
                            className="form-control"
                            name="banco"
                        >
                            <option selected>{selectedPayment.banco}</option>
                            {BANK_OPTIONS.map((bank) => (
                                <option key={bank} value={bank}>
                                    {bank}
                                </option>
                            ))}
                        </select>
                        <label className="required" htmlFor="m-cadastrar-cpf">
                            CPF/CNPJ
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            id="cpf"
                            name="cpf"
                            onInput={formatCpf_Cnpj}
                            value={selectedPayment.cpf}
                            onChange={(event) =>
                                allInputChange(event, setSelectedPayment)
                            }
                        />
                        <label
                            className="required"
                            htmlFor="m-cadastrar-agencia"
                        >
                            Agência
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            maxLength={4}
                            minLength={4}
                            id="agencia"
                            name="agencia"
                            value={selectedPayment.agencia}
                            onChange={(event) =>
                                allInputChange(event, setSelectedPayment)
                            }
                        />
                        <label className="required" htmlFor="m-cadastrar-conta">
                            Conta
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            maxLength={11}
                            minLength={5}
                            id="conta"
                            name="conta"
                            value={selectedPayment.conta}
                            onChange={(event) =>
                                allInputChange(event, setSelectedPayment)
                            }
                        />
                        <label
                            className="required"
                            htmlFor="m-cadastrar-digito"
                        >
                            Dígito
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            maxLength={1}
                            minLength={1}
                            id="digito"
                            name="digito"
                            value={selectedPayment.digito}
                            onChange={(event) =>
                                allInputChange(event, setSelectedPayment)
                            }
                        />
                    </div>
                </div>
            );
        }
    }

    function updatePagamento() {
        const formData = new FormData();
        if (selectedPayment.tipo == "Acordo") {
            const nomes = document.querySelector("#nomes").value;
            const banco = document.querySelector("#banco").value;
            const cpf = document.querySelector("#cpf").value;
            const agencia = document.querySelector("#agencia").value;
            const conta = document.querySelector("#conta").value;
            const digito = document.querySelector("#digito").value;
            const data_pagamento =
                document.querySelector("#data_pagamento").value;
            const valor = document.querySelector("#valor").value;
            const descricao = document.querySelector("#descricao").value;
            const upload = document.querySelector("#upload3");
            if (upload.files.length > 0) {
                formData.append("upload", upload.files[0]);
            }
            formData.append("token", token);
            formData.append("nomes", nomes);
            formData.append("banco", banco);
            formData.append("cpf", cpf);
            formData.append("agencia", agencia);
            formData.append("descricao", descricao);
            formData.append("conta", conta);
            formData.append("digito", digito);
            formData.append("data_pagamento", data_pagamento);
            formData.append("valor", valor);
            axios
                .post(`/api/update/payment/${selectedPayment.id}`, formData, {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((resp) => {
                    if (resp.data.erros.length === 0) {
                        window.location = resp.data.url;
                    } else {
                        for (let i = 0; i < resp.data.erros.length; i++) {
                            let elemento = document.querySelector(
                                `#${resp.data.erros[i].elemento}`
                            );
                            elemento.style.backgroundColor = "#FFC0CB";
                        }
                    }
                });
        } else {
            const data_pagamento =
                document.querySelector("#data_pagamento").value;
            const valor = document.querySelector("#valor").value;
            const upload = document.querySelector("#upload3");
            const descricao = document.querySelector("#descricao").value;
            //const divErros = document.querySelector('#erros')
            if (upload.files.length > 0) {
                formData.append("upload", upload.files[0]);
            }
            formData.append("token", token);
            formData.append("data_pagamento", data_pagamento);
            formData.append("valor", valor);
            formData.append("descricao", descricao);
            axios
                .post(`/api/update/payment/${selectedPayment.id}`, formData, {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((resp) => {
                    if (resp.data.erros.length === 0) {
                        window.location = resp.data.url;
                    } else {
                        for (let i = 0; i < resp.data.erros.length; i++) {
                            let elemento = document.querySelector(
                                `#${resp.data.erros[i].elemento}`
                            );
                            elemento.style.backgroundColor = "#FFC0CB";
                        }
                    }
                });
        }
    }

    return (
        <div
            className="modal fade"
            id="updateModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div
                className="modal-dialog"
                role="document"
                style={{ marginTop: "70px" }}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                            Editar Pagamento
                        </h5>
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body" id="editModal">
                        {startPayment()}

                        <label
                            className="required"
                            htmlFor="m-cadastrar-descricaoLbl"
                        >
                            Informe a data de pagamento da parcela
                        </label>
                        <div
                            className="input-group date"
                            id="reservationdate"
                            data-target-input="nearest"
                        >
                            <input
                                id="data_pagamento"
                                type="date"
                                className="form-control datetimepicker-input"
                                data-target="#reservationdate"
                                name="data_pagamento"
                                value={selectedPayment.data_pagamento}
                                onChange={(event) =>
                                    allInputChange(event, setSelectedPayment)
                                }
                            />
                        </div>
                        <label
                            className="required"
                            htmlFor="m-cadastrar-descricaoLbl"
                        >
                            Informe o valor da parcela do pagamento R$
                        </label>
                        <input
                            id="valor"
                            type="text"
                            value={selectedPayment.valor}
                            className="form-control"
                            name="valor"
                            onChange={(event) =>
                                moneyInputChange(event, setSelectedPayment)
                            }
                        />
                        <label htmlFor="m-cadastrar-descricaoLbl">
                            Informe a descricao
                        </label>
                        <textarea
                            id="descricao"
                            className="form-control"
                            rows="3"
                            name="descricao"
                            onChange={(event) =>
                                allInputChange(event, setSelectedPayment)
                            }
                            value={selectedPayment.descricao}
                        />
                        <div
                            id="anexoDiv"
                            style={{
                                visibility: "visible",
                                display: "block",
                            }}
                        >
                            <label>Anexos:</label>
                            <label className="labelAnexo">
                                {selectedPayment.anexo}
                            </label>
                            {selectedPayment.anexo ? (
                                <>
                                    <span
                                        className="hidden-xs"
                                        title="Excluir"
                                        id="apagarAnexo"
                                        onClick={apagarAnexo}
                                    >
                                        <i
                                            className="fa fa-minus-circle ml-3 btn-remove-anexo text-danger"
                                            style={{
                                                marginTop: 25,
                                                fontSize: "1.25em",
                                                position: "relative",
                                                top: "0.15em",
                                            }}
                                        />
                                    </span>
                                </>
                            ) : (
                                ""
                            )}
                        </div>
                        <input
                            id="anexoEdit"
                            className="form-control"
                            name="anexo"
                            type="text"
                            value={selectedPayment.anexo}
                            style={{
                                visibility: "visible",
                                display: "none",
                            }}
                            readOnly
                        />
                        <div
                            className="row"
                            style={{
                                visibility: "visible",
                                display: "block",
                            }}
                        >
                            <div className="col-10">
                                <label htmlFor="m-cadastrar-descricaoLbl">
                                    Novos anexos
                                </label>
                            </div>
                            <input
                                name="upload"
                                id="upload3"
                                type="file"
                                onChange={selectedAttachmentEditar}
                            />
                            <div className="col-2">
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    title="Upload"
                                    onClick={() => clickUploadUpdatePagamento()}
                                >
                                    <i className="fas fa-file-upload"></i>
                                </button>
                            </div>
                        </div>
                        <div className="col-12" id="novoAnexoEditar"></div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Fechar
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={updatePagamento}
                        >
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdatePagamentoModal;
